import type { IconName } from '@frontend/web-react/components/Primitives/Icon/helpers';
import { TASK_CATEGORY_ICON_MAP } from '@frontend/constants';

export const taskCategoryToIconName = { ...TASK_CATEGORY_ICON_MAP } as const satisfies Record<string, IconName>;

export const getIconNameByTaskCategory = (category?: string): IconName => {
  const name = taskCategoryToIconName[category as keyof typeof taskCategoryToIconName];
  return name || 'IconWindmill';
};
